import { createEffect, createEvent, restore, sample } from 'effector'

import { env } from '@/shared/config'

export const scriptLoaded = createEvent()

export const initFx = createEffect<void, void>()
export const loginFx = createEffect<{ scope?: string[] }, facebook.StatusResponse, facebook.StatusResponse>()
export const getLoginStatusFx = createEffect<void, facebook.StatusResponse, facebook.StatusResponse>()

export const $initialized = restore(
    initFx.done.map(() => true),
    false
)

sample({
    clock: scriptLoaded,
    target: initFx,
})

initFx.use(() => {
    FB.init({
        // Обновлено с v22.0 → v25.0 — актуальная версия (Feb 2026)
        // https://developers.facebook.com/docs/graph-api/changelog/versions/
        version: 'v25.0',
        appId: env.FB_APP_ID,
        // https://developers.facebook.com/community/threads/680742385690883/
        // status: true,
        cookie: true,
        // xfbml отключён: Like/Comment плагины убраны Meta 10 фев 2026,
        // XFBML-элементы в проекте не используются
        // https://developers.facebook.com/blog/post/2025/11/10/platform-evolution-facebook-social-plugins-to-be-discontinued-february-2026/
        xfbml: false,
        // frictionlessRequests убран — legacy-опция для Game Requests,
        // в проекте не используется
    })
})

loginFx.use(async ({ scope }) => {
    const response = await new Promise<facebook.StatusResponse>((resolve, reject) => {
        FB.login(
            (response) => {
                if (response.status === 'connected') {
                    resolve(response)
                } else {
                    reject(response)
                }
            },
            { scope: scope?.join(',') }
        )
    })
    return response
})

getLoginStatusFx.use(async () => {
    const response = await new Promise<facebook.StatusResponse>((resolve, reject) => {
        FB.getLoginStatus((response) => {
            if (response.status === 'connected') {
                resolve(response)
            } else {
                reject(response)
            }
        })
    })
    return response
})
